import React from "react";
import { Share2, ShieldCheck, Eraser, Bot } from "lucide-react";
import Logo from "./Logo";
import { FOOTER } from "@/constants/testIds";
import { purgeEverything } from "@/lib/privacy";

export default function Footer() {
  return (
    <footer data-testid={FOOTER.root} className="relative pt-14 pb-10 border-t" style={{ borderColor: "rgba(166,123,255,0.15)" }}>
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-10">
          <div className="md:col-span-5">
            <Logo />
            <p className="mt-5 max-w-sm text-sm" style={{ color: "var(--violet-soft)" }}>
              Le Chat Gréco-Celtique. Sagesse celtique et guidance philosophique — outils
              gratuits qui vous ramènent à votre libre-arbitre.
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="inline-flex items-center gap-2 text-[11px] font-mono px-3 py-1.5 rounded-full" style={{ background: "rgba(212, 175, 55, 0.1)", border: "1px solid rgba(212, 175, 55, 0.3)", color: "var(--champagne)" }}>
                <ShieldCheck size={12} className="text-gold" /> AES-256-GCM
              </span>
              <span className="inline-flex items-center gap-2 text-[11px] font-mono px-3 py-1.5 rounded-full" style={{ background: "rgba(107, 63, 160, 0.2)", border: "1px solid rgba(214, 193, 255, 0.25)", color: "var(--violet-soft)" }}>
                RGPD · A1
              </span>
              <span className="inline-flex items-center gap-2 text-[11px] font-mono px-3 py-1.5 rounded-full" style={{ background: "rgba(107, 63, 160, 0.2)", border: "1px solid rgba(214, 193, 255, 0.25)", color: "var(--violet-soft)" }}>
                CAPTCHA · Honeypot
              </span>
            </div>
            <button
              type="button"
              onClick={() => {
                if (window.confirm("Effacer toutes vos données locales et serveur, et revenir à l'accueil ?")) {
                  purgeEverything("manual");
                }
              }}
              data-testid="footer-purge"
              className="mt-5 btn-ghost !text-[11px] inline-flex items-center gap-2"
            >
              <Eraser size={13} />
              Effacer & partir
            </button>
          </div>
          <FooterCol title="Consultations" links={[["Oracles", "/traditions#oracles"], ["Barde", "/barde"], ["Druide", "/druide"], ["Guantraí", "/guantrai"], ["Pub", "/pub"], ["Suantraí", "/suantrai"], ["Gaïa", "/gaia"]]} />
          <FooterCol title="Découvrir" links={[["Présentation", "/decouvrir"], ["Personnages", "/#personnages"], ["Traditions", "/traditions"]]} />
          <FooterCol title="Légal" links={[["Confidentialité", "/privacy"], ["Avertissement IA", "/privacy#ia"], ["Cookies & stockage", "/privacy#stockage"]]} />
        </div>
        <div className="hair mb-6" />
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div className="text-xs font-mono" style={{ color: "var(--muted)" }}>
            © {new Date().getFullYear()} Le Chat Gréco-Celtique · À but divertissant · 18 ans et +
            <br />
            <span data-testid="footer-ai-notice" className="inline-flex items-center gap-1.5 my-1" style={{ color: "var(--champagne)" }}>
              <Bot size={12} /> Tous les personnages sont des intelligences artificielles · contenu de divertissement, sans valeur de conseil professionnel.
            </span>
            <br />
            <span className="opacity-70">
              Musique · <a href="https://incompetech.com" target="_blank" rel="noopener noreferrer" style={{ color: "var(--gold)" }}>Kevin MacLeod · incompetech.com</a> ·{" "}
              <a href="https://creativecommons.org/licenses/by/3.0/" target="_blank" rel="noopener noreferrer" style={{ color: "var(--gold)" }}>CC-BY 3.0</a>
            </span>
          </div>
          <div className="flex items-center gap-3">
            <a href="/decouvrir" data-testid="footer-share-link" className="btn-ghost inline-flex items-center gap-2 !py-2 !px-4 !text-[11px]">
              <Share2 size={13} /> Partager le site
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div className="md:col-span-2">
      <div className="text-xs font-mono uppercase tracking-[0.28em] mb-4" style={{ color: "var(--gold)" }}>
        {title}
      </div>
      <ul className="space-y-2">
        {links.map(([label, href]) => (
          <li key={label}>
            <a href={href} className="text-sm hover:text-white transition-colors" style={{ color: "var(--violet-soft)" }}>
              {label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
